module.exports = __webpack_public_path__ + "img/Patch8-2.a8ef4334.webp";